module.exports = __webpack_public_path__ + "img/comment.db7aa9c2.svg";